import Action from "./Action";
import Shape from "../Main/Shape.js";
import {Serialization} from "../Main/Serializer";

export default class ShapeChangeColorAction implements Action {

    private readonly oldColor: string;

    constructor(private shape: Shape, private newColor: string) {
        this.oldColor = this.shape.getColor();
    }

    public apply() {
        this.shape.setColor(this.newColor);
    }

    public revert() {
        this.shape.setColor(this.oldColor);
    }

    public merge(newAction: Action): boolean {
        return false;
    }

    public serializeForDebug(): Serialization {
        return {
            shape: this.shape.id,
            oldColor: this.oldColor,
            newColor: this.newColor,
        };
    }
}
